import { APIModel } from "app/state/api";
import { CMSApiCallModel } from "../../interfaces";

const pagesDataHub: CMSApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_CMS_API}/pages-data-hub`),
};

export default pagesDataHub;
